import {NavigateOptions, useLocation, useNavigate} from 'react-router-dom';
import tryGetLanguageTokenFromString from "../localization/tryGetLanguageTokenFromString";
import getLanguageFromPath from "../localization/getLanguageFromPath";
import removeDuplicateSlashes from "../util/str/removeDuplicateSlashes";
import {LANGUAGE_TOKEN} from "../redux/slice/languageSlice";

// These types can be replaced by Navigate & NavigateProps, but I can't find the types for it
export type IRedirectOptions = NavigateOptions;
export type IRedirect = (path: string, options?: IRedirectOptions, search?: string, newLang?: LANGUAGE_TOKEN) => void;
export default function useRedirect(): IRedirect {
    const {pathname} = useLocation();
    const navigate = useNavigate();

    return (path: string, options?: NavigateOptions, search?: string, newLanguageToken?: LANGUAGE_TOKEN) => {
        const languageFromPath = getLanguageFromPath(pathname);
        const currentLanguageToken = tryGetLanguageTokenFromString(languageFromPath);
        const currentLanguageTokenOrDefault = currentLanguageToken ?? 'EN';

        const targetLanguageToken = newLanguageToken ?? currentLanguageTokenOrDefault;
        const targetPath = removeDuplicateSlashes(`/${targetLanguageToken.toLowerCase()}/${path}`);

        search ? navigate({pathname: targetPath, search}, options): navigate(targetPath, options);
    }
}
